import Analytics from 'analytics'
import segmentPlugin from '@analytics/segment'
import { getLiveConfigurationCache } from './configuration/configurationCache'
import cdpDumpPlugin from './cdpDumpPlugin'
import { getAOrBVariant } from './featureCohortTesting'

let segmentAnalytics = null
let plickersAnalytics = null

function initAnalytics() {
  segmentAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      segmentPlugin({
        writeKey: process.env.REACT_APP_SEGMENT_KEY,
      }),
    ],
  })
  plickersAnalytics = Analytics({
    app: 'plickers-web',
    plugins: [
      cdpDumpPlugin({
        appName: 'plickers-web',
        writeKey: process.env.REACT_APP_CDPDUMP_WRITE_KEY,
        host: process.env.REACT_APP_CDPDUMP_HOST,
        endpointPrefix: '/cdp/v1',
        // enableDebugLogging: true, // enable this to get more logs into browser console
      }),
    ],
  })
}

export function getAnalyticsProvider() {
  const userId = JSON.parse(localStorage.getItem('ls.session'))?.user
  const liveConfig = getLiveConfigurationCache() || {}
  const {
    analyticsProviderProbabilityUser,
    analyticsProviderProbabilityAnonymous,
  } = liveConfig

  if (userId) {
    const defaultProbabilityUser = process.env.REACT_APP_ANALYTICS_PROVIDER_DEFAULT_PROBABILITY_USER
    const userProbability = (analyticsProviderProbabilityUser ?? defaultProbabilityUser) ?? '0'
    console.log(
      '[ANALYTICS] USER PROBABILITY', userProbability,
      'default:', defaultProbabilityUser,
      'analyticsProviderProbabilityUser:', analyticsProviderProbabilityUser,
      'userId:', userId,
    )
    return getAOrBVariant('analyticsProviderUser', userId, userProbability) === 'A' ?
      'segment' : 'plickers'
  }

  const segmentAnonymousId = window.analytics?.user?.().anonymousId()
  if (segmentAnonymousId) {
    const defaultProbabilityAnonymous = process.env.REACT_APP_ANALYTICS_PROVIDER_DEFAULT_PROBABILITY_ANONYMOUS
    const anonymousProbability = (analyticsProviderProbabilityAnonymous ?? defaultProbabilityAnonymous) ?? '0'
    console.log(
      '[ANALYTICS] ANONYMOUS PROBABILITY', anonymousProbability,
      'default:', defaultProbabilityAnonymous,
      'analyticsProviderProbabilityAnonymous:', analyticsProviderProbabilityAnonymous,
      'segmentAnonymousId:', segmentAnonymousId,
    )
    return getAOrBVariant('analyticsProviderAnonymous', segmentAnonymousId, anonymousProbability) === 'A' ?
      'segment' : 'plickers'
  }

  // if no userId or segment anonymousId is available, default to plickers
  console.log('[ANALYTICS] no userId or anonymousId, defaulting to plickers')
  return 'plickers'
}

function getAnalyticsInstance() {
  const analyticsProvider = getAnalyticsProvider()
  console.log('Selected analytics provider:', analyticsProvider)
  if (analyticsProvider === 'segment' && isSegmentInitialized()) {
    return segmentAnalytics
  }
  if (analyticsProvider === 'plickers') {
    return plickersAnalytics
  }
}

function isSegmentInitialized() {
  return !!window.analytics
}

function track(eventName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.track(eventName, properties)
  }
}

function page(pageName, properties = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.page({
      name: pageName,
      ...properties,
    })
  }
}

function identify(userId, traits = {}) {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.identify(userId, traits)
  }
}

function reset() {
  const analytics = getAnalyticsInstance()
  if (analytics) {
    analytics.reset()
  }
}

export default {
  initAnalytics,
  track,
  page,
  identify,
  reset,
}
